import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';
import { FileService } from 'src/app/_services/file.service';
import * as fileSaver from 'file-saver';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-pasajero-confirmado',
  templateUrl: './pasajero-confirmado.component.html',
  styleUrls: ['./pasajero-confirmado.component.css']
})
export class PasajeroConfirmadoComponent implements OnInit, OnDestroy {

  subscriptionPlanilla: Subscription;
  idPasajero: Number;
  idPasajerorecibido: Number;
  pasajeroHabitacion = [];
  datosPasajero = [];
  collapsed = true;
  modalOptions:NgbModalOptions;
  ficha: any;
  //doc: any;
  docCargado = [];
  fichaCargada = [];


  pasajeroFicha: {
    nombre: string,
    telefono:string,
    email: string,
    tipoDoc: string,
    numerDoc: string,
    observaciones: string,
    imagen: string,
    ficha: string,
    nombreEmergencia: string,
    telefonoEmergencia: string,
    comprobante: string,
    instagram: string,
    facebook: string,
    twitter: string,
    estado: string,
    idReservacion: string,
    tipoHabitacion: string,
    asiento:string
  };

  constructor(
    private agenciasService:AgenciasService,
    private filesService:FileService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
    private modalService: NgbModal
  ) { }
  ngOnDestroy(): void {
    this.subscriptionPlanilla.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptionPlanilla = this.tourservice.pasajeroConfirmado.subscribe(result => {
      this.idPasajero = result;
    });

    //obtener documentos
    this.agenciasService.getDocumentos(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.docCargado = data.body;                  
        }        
      }    
    }); 

    //obtener fichas
    this.agenciasService.getFichas(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.fichaCargada = data.body;                  
        }        
      }    
    });  

    this.detallesPasajeroCfm();
  }

  detallesPasajeroCfm(){  //Todo redireccionar a los pasajeros confirmados
    this.datosPasajero = [];
    this.agenciasService.pasajeroReservacion(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.datosPasajero = data.body; 
          this.idPasajerorecibido = data.body.id;
          this.pasajeroHabitacion = data.body.id_tipoHabitacion;
          var response = data.body;
        }
        //console.log(this.datosPasajero);
        //console.log('el tipo de habitacion reservado es:  ' + data.body.id_tipoHabitacion.id  );
        this.pasajeroFicha = {
          nombre: this.getValue(response.nombre_pasajero),
          telefono:this.getValue(response.telefono_pasajero),
          email: this.getValue(response.email_pasajero),
          tipoDoc: this.getValue(response.tipo_documento),
          numerDoc: this.getValue(response.numero_documento),
          observaciones: this.getValue(response.observaciones_pasajero),
          imagen: this.getValue(response.imagen_documento),
          ficha: this.getValue(response.ficha_medica),
          nombreEmergencia: this.getValue(response.nombre_emergencia),
          telefonoEmergencia: this.getValue(response.telefono_emergencia),
          comprobante: this.getValue(response.comprobante),
          instagram: this.getValue(response.instagram_pasajero),
          facebook: this.getValue(response.facebook_pasajero),
          twitter: this.getValue(response.twitter_pasajero),
          estado: this.getValue(response.estado),
          idReservacion: this.getValue(response.id_reservacion),
          tipoHabitacion: this.getValue(response.id_tipoHabitacion),
          asiento: this.getValue(response.asiento),
        }   
      }    
    });    
  }

  getValue(cadena: string){
    return (cadena === null || cadena === undefined || cadena === '')?'-':cadena;
  }

  descargarFicha() { 
    if(!this.fichaCargada.length){ //*pasajero no tiene ficha en bd
      const modalRef = this.modalService.open(ModalMsgComponent, { 
        centered: true,  
        backdrop:'static',      
      });
      modalRef.componentInstance.titulo = 'Sin Ficha Médica';
      modalRef.componentInstance.check = 0; 
      modalRef.componentInstance.label = 'Aceptar';
    } else {
        for(let i=0; i<this.fichaCargada.length; i++){
          this.filesService.descargarFicha(this.fichaCargada[i].id).subscribe(response => {
            var blob: any;
            if(response.type === 'application/pdf'){
              blob = new Blob([response], { type: 'application/pdf; charset=utf-8' });              
            }
            else {              
              blob = new Blob([response], { type: response.type });
            }
            const url = window.URL.createObjectURL(blob);
            var ficha = new String( "Ficha Médica "); 
            var nombreFicha = ficha.concat( this.pasajeroFicha.nombre.toString());
			      //window.open(url);
			      //window.location.href = response.url;
			      fileSaver.saveAs(blob, nombreFicha);
        }), error => console.log('Error downloading the file'),
        () => console.info('File downloaded successfully');
        }
    }
  }

  descargarDoc() {
    if(!this.docCargado.length){      
      const modalRef = this.modalService.open(ModalMsgComponent, { 
        centered: true,  
        backdrop:'static',      
      });
      modalRef.componentInstance.titulo = 'Sin Documento';
      modalRef.componentInstance.check = 0; 
      modalRef.componentInstance.label = 'Aceptar';
    } else {
      for(let i=0; i<this.docCargado.length; i++){
        this.filesService.descargarDoc(this.docCargado[i].id).subscribe(response => {
          var blob: any;
          if(response.type === 'application/pdf'){
            blob = new Blob([response], { type: 'application/pdf; charset=utf-8' });              
          }
          else {              
            blob = new Blob([response], { type: response.type });
          }
          const url = window.URL.createObjectURL(blob);
          var doc = new String( "Documento de Identidad " ); 
          var nombreDoc = doc.concat( this.pasajeroFicha.nombre.toString());
          fileSaver.saveAs(blob, nombreDoc); 
        }), error => console.log('Error downloading the file'),
                   () => console.info('File downloaded successfully');

      }
    }    
  }

  descargarPlanilla() {
    this.filesService.descargarPlanilla(this.idPasajerorecibido).subscribe(response => {
			let blob:any = new Blob([response], { type: 'application/pdf; charset=utf-8' });
			const url = window.URL.createObjectURL(blob);
      var doc = new String( "Planilla " ); 
      var nombreDoc = doc.concat( this.pasajeroFicha.nombre.toString());
			fileSaver.saveAs(blob, nombreDoc);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully');
  }

}
